import { render } from "./PasswordField.vue?vue&type=template&id=48f9d488&scoped=true"
import script from "./PasswordField.vue?vue&type=script&lang=js"
export * from "./PasswordField.vue?vue&type=script&lang=js"

import "./PasswordField.vue?vue&type=style&index=0&id=48f9d488&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f9d488"]])

export default __exports__